export default __webpack_public_path__ + "static/soc2-ai-startup-competitive-edge-aa1e7c725c9a3f9fe792ea9454c29dd9.jpg";